import React, { useState } from 'react';

const CardStep3 = ({ setCurrentStep }) => {
   const [cardNumber, setCardNumber] = useState('');
   const [expiry, setExpiry] = useState('');
   const [cvv, setCvv] = useState('');
   const [cardType, setCardType] = useState('');
   // Agregar estados faltantes
   const [firstName, setFirstName] = useState('');
   const [lastName, setLastName] = useState('');
   const [country, setCountry] = useState('');
   const [zip, setZip] = useState('');

   const detectCardType = (number) => {
      const cleanNumber = number.replace(/\D/g, '');
      // Patrones de las tarjetas
      const patterns = {
         visa: /^4/,
         mastercard: /^5[1-5]/,
         amex: /^3[47]/,
         discover: /^6(?:011|5)/,
         diners: /^3(?:0[0-5]|[68])/,
         jcb: /^(?:2131|1800|35\d{3})/
      };
      // Verificar cada patrón
      for (const [type, pattern] of Object.entries(patterns)) {
         if (pattern.test(cleanNumber)) {
            return type;
         }
      }
      return ''; // Si no coincide con ningún patrón
   };
   const handleCardNumberChange = (e) => {
      let value = e.target.value;
      // Elimina todos los caracteres no numéricos
      value = value.replace(/[^\d]/g, '');
      // Detecta si es AMEX antes de formatear
      const isAmex = /^3[47]/.test(value);
      if (isAmex) {
         // Formato AMEX: XXXX XXXXXX XXXXX (4-6-5)
         let formatted = '';
         if (value.length > 0) {
            formatted = value.slice(0, 4);
            if (value.length > 4) {
               formatted += ' ' + value.slice(4, 10);
               if (value.length > 10) {
                  formatted += ' ' + value.slice(10, 15);
               }
            }
         }
         // Limita a 15 dígitos para AMEX
         if (value.length <= 15) {
            setCardNumber(formatted);
            setCardType('amex');
         }
      } else {
         // Formato normal: XXXX XXXX XXXX XXXX
         value = value.replace(/(\d{4})/g, '$1 ').trim();
         // Limita a 16 dígitos + espacios para otras tarjetas
         if (value.replace(/\s/g, '').length <= 16) {
            setCardNumber(value);
            setCardType(detectCardType(value));
         }
      }
   };
   const handleExpiryChange = (e) => {
      let value = e.target.value.replace(/\D/g, ''); // Elimina no números
      if (value.length >= 2) {
         // Cuando hay 2 o más números, agrega el / después de los primeros 2
         setExpiry(`${value.slice(0, 2)}/${value.slice(2, 4)}`);
      } else {
         // Si hay menos de 2 números, muestra los números tal cual
         setExpiry(value);
      }
   };
   const handleCvvChange = (e) => {
      const value = e.target.value.replace(/\D/g, ''); // Solo permite números
      const maxLength = cardType === 'amex' ? 4 : 3; // 4 dígitos para AMEX, 3 para otras

      if (value.length <= maxLength) {
         setCvv(value);
      }
   };
   // Función para validar todos los campos
   const isFormValid = () => {
      return (
         firstName.trim() !== '' &&
         lastName.trim() !== '' &&
         cardNumber.trim() !== '' &&
         expiry.trim() !== '' &&
         cvv.trim() !== '' &&
         country.trim() !== '' &&
         zip.trim() !== ''
      );
   };

   // Manejadores para los nuevos campos
   const handleFirstNameChange = (e) => {
      setFirstName(e.target.value);
   };

   const handleLastNameChange = (e) => {
      setLastName(e.target.value);
   };

   const handleCountryChange = (e) => {
      setCountry(e.target.value);
   };

   const handleZipChange = (e) => {
      setZip(e.target.value);
   };

   return (
      <div className="modal_content_body">
         <h3 className="ppt_form_title mb-4 text-center">Credit / Debit card payment</h3>
         <div className='ppt_deposit_ex gap-2 align-items-start'>
            <div className="w-100 d-flex flex-column gap-2 mx-auto" style={{ maxWidth: '320px' }}>
               <div className='ppt_deposit_item justify-content-start p-3'>
                  <img src={process.env.PUBLIC_URL + '/assets/img/lm_logo_propert.svg'} alt="" style={{ width: '100px' }} />
               </div>
               <div className='ppt_deposit_item justify-content-start p-3'>
                  <div className='row gap-3 m-0'>
                     <div className="ppt_input_style col px-0">
                        <label>First Name</label>
                        <div>
                           <input
                              className='form-control'
                              type="text"
                              value={firstName}
                              onChange={handleFirstNameChange}
                              autoComplete="off"
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style col px-0">
                        <label>Last Name</label>
                        <div>
                           <input
                              className='form-control'
                              type="text"
                              value={lastName}
                              onChange={handleLastNameChange}
                              autoComplete="off"
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style col-12 px-0">
                        <label>Card number</label>
                        <div className="position-relative">
                           <input
                              className='form-control'
                              type="text"
                              value={cardNumber}
                              onChange={handleCardNumberChange}
                              placeholder={cardType === 'amex' ? "" : ""}
                              maxLength={cardType === 'amex' ? 17 : 19} // 17 para AMEX (15 números + 2 espacios), 19 para otros (16 números + 3 espacios)
                           />
                           {cardType && (
                              <img
                                 src={process.env.PUBLIC_URL + `/assets/img/logo_${cardType}.svg`}
                                 alt={cardType}
                                 className="position-absolute"
                                 style={{
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '20px'
                                 }}
                              />
                           )}
                        </div>
                     </div>
                  </div>
                  <div className='row gap-3 m-0'>
                     <div className="ppt_input_style col px-0">
                        <label>Expiry</label>
                        <div>
                           <input
                              className='form-control'
                              type="text"
                              value={expiry}
                              onChange={handleExpiryChange}
                              placeholder="MM/YY"
                              maxLength={5}
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style col px-0">
                        <label>CVV</label>
                        <div>
                           <input
                              className='form-control'
                              type="text"
                              value={cvv}
                              onChange={handleCvvChange}
                              maxLength={cardType === 'amex' ? 4 : 3}
                              placeholder={cardType === 'amex' ? "0000" : "000"}
                           />
                        </div>
                     </div>
                  </div>
                  <div className='row gap-3 m-0'>
                     <div className="ppt_input_style col px-0">
                        <label>Country</label>
                        <div>
                           <select
                              name="country"
                              id="country"
                              className='form-select'
                              value={country}
                              onChange={handleCountryChange}
                              autoComplete="off"
                           >
                              <option value=""></option>
                              <option value="Afghanistan">Afghanistan</option>
                              <option value="Albania">Albania</option>
                              <option value="Algeria">Algeria</option>
                              <option value="Andorra">Andorra</option>
                              <option value="Angola">Angola</option>
                              <option value="Anguilla">Anguilla</option>
                              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                              <option value="Argentina">Argentina</option>
                              <option value="Armenia">Armenia</option>
                              <option value="Aruba">Aruba</option>
                              <option value="Australia">Australia</option>
                              <option value="Austria">Austria</option>
                              <option value="Azerbaijan">Azerbaijan</option>
                              <option value="Bahamas">Bahamas</option>
                              <option value="Bahrain">Bahrain</option>
                              <option value="Bangladesh">Bangladesh</option>
                              <option value="Barbados">Barbados</option>
                              <option value="Belarus">Belarus</option>
                              <option value="Belgium">Belgium</option>
                              <option value="Belize">Belize</option>
                              <option value="Benin">Benin</option>
                              <option value="Bermuda">Bermuda</option>
                              <option value="Bhutan">Bhutan</option>
                              <option value="Bolivia">Bolivia</option>
                              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                              <option value="Botswana">Botswana</option>
                              <option value="Brazil">Brazil</option>
                              <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                              <option value="Brunei">Brunei</option>
                              <option value="Bulgaria">Bulgaria</option>
                              <option value="Burkina Faso">Burkina Faso</option>
                              <option value="Myanmar">Myanmar</option>
                              <option value="Burundi">Burundi</option>
                              <option value="Cambodia">Cambodia</option>
                              <option value="Cameroon">Cameroon</option>
                              <option value="Canada">Canada</option>
                              <option value="Cape Verde">Cape Verde</option>
                              <option value="Cayman Islands">Cayman Islands</option>
                              <option value="Central African Republic">Central African Republic</option>
                              <option value="Chad">Chad</option>
                              <option value="Christmas Island">Christmas Island</option>
                              <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                              <option value="Cook Islands">Cook Islands</option>
                              <option value="Chile">Chile</option>
                              <option value="China">China</option>
                              <option value="Colombia">Colombia</option>
                              <option value="Comoros">Comoros</option>
                              <option value="Congo">Congo</option>
                              <option value="Costa Rica">Costa Rica</option>
                              <option value="Croatia">Croatia</option>
                              <option value="Cuba">Cuba</option>
                              <option value="Cyprus">Cyprus</option>
                              <option value="Czech Republic">Czech Republic</option>
                              <option value="Denmark">Denmark</option>
                              <option value="Djibouti">Djibouti</option>
                              <option value="Dominica">Dominica</option>
                              <option value="Dominican Republic">Dominican Republic</option>
                              <option value="Timor-Leste">Timor-Leste</option>
                              <option value="Tokelau">Tokelau</option>
                              <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                              <option value="Ecuador">Ecuador</option>
                              <option value="Egypt">Egypt</option>
                              <option value="El Salvador">El Salvador</option>
                              <option value="Equatorial Guinea">Equatorial Guinea</option>
                              <option value="Eritrea">Eritrea</option>
                              <option value="Estonia">Estonia</option>
                              <option value="Ethiopia">Ethiopia</option>
                              <option value="Faroe Islands">Faroe Islands</option>
                              <option value="Falkland Islands">Falkland Islands</option>
                              <option value="Fiji">Fiji</option>
                              <option value="Finland">Finland</option>
                              <option value="France">France</option>
                              <option value="French Polynesia">French Polynesia</option>
                              <option value="Gabon">Gabon</option>
                              <option value="Gambia">Gambia</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Gibraltar">Gibraltar</option>
                              <option value="Germany">Germany</option>
                              <option value="Ghana">Ghana</option>
                              <option value="Greece">Greece</option>
                              <option value="Greenland">Greenland</option>
                              <option value="Guadeloupe">Guadeloupe</option>
                              <option value="Grenada">Grenada</option>
                              <option value="Guernsey">Guernsey</option>
                              <option value="Guatemala">Guatemala</option>
                              <option value="Guam">Guam</option>
                              <option value="Guinea">Guinea</option>
                              <option value="Guinea-Bissau">Guinea-Bissau</option>
                              <option value="Guyana">Guyana</option>
                              <option value="Haiti">Haiti</option>
                              <option value="Heard Island and McDonald Islands">Heard Island and McDonald Islands</option>
                              <option value="Jordan">Jordan</option>
                              <option value="Honduras">Honduras</option>
                              <option value="Hong Kong">Hong Kong</option>
                              <option value="Hungary">Hungary</option>
                              <option value="Iceland">Iceland</option>
                              <option value="India">India</option>
                              <option value="Indonesia">Indonesia</option>
                              <option value="Iran">Iran</option>
                              <option value="Iraq">Iraq</option>
                              <option value="Ireland">Ireland</option>
                              <option value="Isle of Man">Isle of Man</option>
                              <option value="Israel">Israel</option>
                              <option value="Italy">Italy</option>
                              <option value="Ivory Coast">Ivory Coast</option>
                              <option value="Jamaica">Jamaica</option>
                              <option value="Jersey">Jersey</option>
                              <option value="Japan">Japan</option>
                              <option value="Kazakhstan">Kazakhstan</option>
                              <option value="Kenya">Kenya</option>
                              <option value="Kiribati">Kiribati</option>
                              <option value="North Korea">North Korea</option>
                              <option value="Kosovo">Kosovo</option>
                              <option value="Kuwait">Kuwait</option>
                              <option value="Kyrgyzstan">Kyrgyzstan</option>
                              <option value="Laos">Laos</option>
                              <option value="Latvia">Latvia</option>
                              <option value="Lebanon">Lebanon</option>
                              <option value="Lesotho">Lesotho</option>
                              <option value="Liberia">Liberia</option>
                              <option value="Libya">Libya</option>
                              <option value="Liechtenstein">Liechtenstein</option>
                              <option value="Luxembourg">Luxembourg</option>
                              <option value="Lithuania">Lithuania</option>
                              <option value="Macedonia">Macedonia</option>
                              <option value="Madagascar">Madagascar</option>
                              <option value="Malawi">Malawi</option>
                              <option value="Malaysia">Malaysia</option>
                              <option value="Maldives">Maldives</option>
                              <option value="Mali">Mali</option>
                              <option value="Malta">Malta</option>
                              <option value="Mexico">Mexico</option>
                              <option value="Moldova">Moldova</option>
                              <option value="Monaco">Monaco</option>
                              <option value="Mongolia">Mongolia</option>
                              <option value="Montenegro">Montenegro</option>
                              <option value="Morocco">Morocco</option>
                              <option value="Mozambique">Mozambique</option>
                              <option value="Namibia">Namibia</option>
                              <option value="Nepal">Nepal</option>
                              <option value="Netherlands">Netherlands</option>
                              <option value="New Zealand">New Zealand</option>
                              <option value="Nicaragua">Nicaragua</option>
                              <option value="Niger">Niger</option>
                              <option value="Nigeria">Nigeria</option>
                              <option value="Norway">Norway</option>
                              <option value="Oman">Oman</option>
                              <option value="Pakistan">Pakistan</option>
                              <option value="Panama">Panama</option>
                              <option value="Papua New Guinea">Papua New Guinea</option>
                              <option value="Paraguay">Paraguay</option>
                              <option value="Peru">Peru</option>
                              <option value="Philippines">Philippines</option>
                              <option value="Poland">Poland</option>
                              <option value="Portugal">Portugal</option>
                              <option value="Qatar">Qatar</option>
                              <option value="Romania">Romania</option>
                              <option value="Russia">Russia</option>
                              <option value="Rwanda">Rwanda</option>
                              <option value="Saudi Arabia">Saudi Arabia</option>
                              <option value="Senegal">Senegal</option>
                              <option value="Serbia">Serbia</option>
                              <option value="Singapore">Singapore</option>
                              <option value="Slovakia">Slovakia</option>
                              <option value="Slovenia">Slovenia</option>
                              <option value="Somalia">Somalia</option>
                              <option value="South Africa">South Africa</option>
                              <option value="South Korea">South Korea</option>
                              <option value="Spain">Spain</option>
                              <option value="Sri Lanka">Sri Lanka</option>
                              <option value="Sudan">Sudan</option>
                              <option value="Sweden">Sweden</option>
                              <option value="Switzerland">Switzerland</option>
                              <option value="Syria">Syria</option>
                              <option value="Taiwan">Taiwan</option>
                              <option value="Tanzania">Tanzania</option>
                              <option value="Thailand">Thailand</option>
                              <option value="Togo">Togo</option>
                              <option value="Tunisia">Tunisia</option>
                              <option value="Turkey">Turkey</option>
                              <option value="Uganda">Uganda</option>
                              <option value="Ukraine">Ukraine</option>
                              <option value="United Arab Emirates">United Arab Emirates</option>
                              <option value="United Kingdom">United Kingdom</option>
                              <option value="United States">United States</option>
                              <option value="Uruguay">Uruguay</option>
                              <option value="Uzbekistan">Uzbekistan</option>
                              <option value="Venezuela">Venezuela</option>
                              <option value="Vietnam">Vietnam</option>
                              <option value="Yemen">Yemen</option>
                              <option value="Zambia">Zambia</option>
                              <option value="Zimbabwe">Zimbabwe</option>
                           </select>
                        </div>
                     </div>
                     <div className="ppt_input_style col px-0">
                        <label>ZIP Code</label>
                        <div>
                           <input
                              className='form-control'
                              type="text"
                              value={zip}
                              onChange={handleZipChange}
                              autoComplete="off"
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style col-12 px-0">
                        <button
                           className="ppt_btn_primary alt"
                           onClick={() => setCurrentStep(4)}
                           disabled={!isFormValid()}
                           style={{ fontSize: '13px', padding: '10px 16px' }}
                        >
                           Continue
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default CardStep3;